import { Navigate } from 'react-router-dom';
import { useKeycloak } from '@react-keycloak/web';
import { CircularProgress, Box } from '@mui/material';

const ProtectedRoute = ({ children, role }) => {
  const { keycloak, initialized } = useKeycloak();

  // Wait for Keycloak to initialize
  if (!initialized) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          backgroundColor: '#121212'
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // Redirect to home if not authenticated
  if (!keycloak.authenticated) {
    return <Navigate to="/" replace />;
  }

  // Check for required role
  if (role) {
    const userRoles = keycloak.realmAccess?.roles || [];
    if (!userRoles.includes(role)) {
      return <Navigate to="/home" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
